import React, { useEffect, useState } from 'react';
import { Row, Col, Spin, Card, Divider, Button } from 'antd';
import { useQuery } from '@apollo/react-hooks';
import { LoadingOutlined, ShoppingCartOutlined } from '@ant-design/icons';

import { queries } from '../../graphql/graphql';
import { formatPrice, gaEvent } from '../../utils';
import _s from './index.less';

const { Meta } = Card;
const antIcon = <LoadingOutlined style={{ fontSize: 40 }} spin />;

const ProductCard = ({ item }) => {
  const [hovered, setHovered] = useState(false);

  function capitalizeFirstLetter(str) {
    if (!str) return ''; // Проверка на пустую строку
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }

  return (
    <Col span={24} md={12} lg={6}>
      <Card
        hoverable
        cover={item.img && <img alt="" className={_s.summaryImg} src={item.img} />}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        <Meta
          title={item.title}
          description={
            <>
              <p>${formatPrice(item.price)}</p>
              <p style={{ minHeight: '22px' }}>{capitalizeFirstLetter(item.description)}</p>
              <div style={{ minHeight: '32px' }}>
                {item.url && (
                  <Button
                    type="primary"
                    icon={<ShoppingCartOutlined />}
                    href={item.url}
                    disabled={!item.url}
                    target="_blank"
                    style={{ marginTop: '10px', float: 'right' }}
                  >
                    {hovered ? 'Check in store' : ''}
                  </Button>
                )}
              </div>
            </>
          }
        />
      </Card>
    </Col>
  );
};

const ProductList = ({ list }) =>
  list &&
  list.length &&
  list.map((item, key) => {
    if (item.data && item.data.length) {
      return <ProductList key={`product-${key}`} list={item.data} />;
    }
    return <ProductCard key={`product-${key}`} item={item} />;
  });

const LinesList = ({ list, showPrice = true, showTotal = true, disclaimer = '' }) => {
  const [hovered, setHovered] = useState('');
  return (
    <Col span={24}>
      <Row gutter={[16, 16]} justify="space-around" align="middle">
        <Col span={24} md={20} lg={16}>
          <span className={_s.summaryListTitle}>{list.title}</span>
        </Col>

        <Col span={24} md={20} lg={16}>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
            {list.data.map((item, index) => (
              <li
                onMouseEnter={() => setHovered(`lines-${list.title}-${index}`)}
                onMouseLeave={() => setHovered('')}
                className={_s.summaryListItem}
                key={`lines-${list.title}-${index}`}
              >
                <span className={_s.summaryListItemTitle}>{item.title}</span>
                <span className={_s.summaryListItemTitle}>
                  {showPrice ? <>${formatPrice(item.price)}</> : '*'}
                  {item.type === 'materials' && (
                    <Button
                      type="primary"
                      icon={<ShoppingCartOutlined />}
                      href={item.url}
                      disabled={!item.url}
                      target="_blank"
                      style={{ marginTop: '10px', float: 'right', marginLeft: '10px' }}
                    >
                      {hovered === `lines-${list.title}-${index}` && item.url
                        ? 'Check in store'
                        : ''}
                    </Button>
                  )}
                </span>
              </li>
            ))}
          </ul>
        </Col>

        {showTotal && (
          <Col span={24} md={20} lg={16}>
            <Divider style={{ margin: 0 }} />
            <Row justify="space-between">
              <span className={_s.summaryListItemTitle}>Total {list.title}</span>
              <span className={_s.summaryListItemTitle}>
                ${formatPrice(list.price)}
                {disclaimer && '*'}
              </span>
            </Row>
          </Col>
        )}

        {disclaimer && (
          <Col span={24} md={20} lg={16}>
            <span className={_s.summaryListItemTitle}>*Prices vary depending on location.</span>
          </Col>
        )}
      </Row>
    </Col>
  );
};

const Summary = ({ plan, setPrice }) => {
  const { data = {}, loading, refetch } = useQuery(queries.GET_SUMMARY, {
    variables: { id: plan.id }
  });
  const { getSummary } = data;

  useEffect(() => {
    refetch();
  }, [plan.id]);

  useEffect(() => {
    if (getSummary && getSummary.data) setPrice(getSummary.data.price);
  }, [getSummary]);

  if (!loading && (!getSummary || !getSummary.data)) return null;

  if (loading)
    return (
      <Row justify="center">
        <Col>
          <Spin size="large" indicator={antIcon} />
        </Col>
      </Row>
    );

  const onClickCTA = e => {
    e.preventDefault();
    gaEvent('planView', 'click:configure', 'configure');
    window.open(plan.url, '_blank');
  };

  return (
    <Row style={{ paddingLeft: 16, paddingRight: 16 }}>
      <Col span={24}>
        <Row>
          <Col span={24}>
            <span className={_s.block_title}>Estimate Details</span>
          </Col>
        </Row>
        <Row justify="space-around" align="middle">
          {getSummary && getSummary.data && getSummary.data.preconstruction && (
            <>
              <LinesList
                list={getSummary.data.preconstruction}
                showPrice={false}
                disclaimer="Prices vary depending on location."
              />
            </>
          )}
          {getSummary && getSummary.data && getSummary.data.products && (
            <Col span={24} md={20} lg={16}>
              {getSummary.data.products.map((product, index) => (
                <Row gutter={[16, 16]} key={`category-${index}`}>
                  <Col span={24}>
                    <span className={_s.titlePlan}>{product.title}</span>
                  </Col>
                  <Col span={24}>
                    <Row gutter={[16, 16]} key={`category-${index}`}>
                      <ProductList list={product.data} />
                    </Row>
                  </Col>
                </Row>
              ))}
            </Col>
          )}
          <Col span={24} md={20} lg={16}>
            <Row justify="center" align="middle">
              <Col>
                <Button
                  size="large"
                  style={{
                    // todo
                    background: '#EE8865',
                    fontSize: '18px',
                    lineHeight: '21px',
                    textAlign: 'center',
                    width: '300px',
                    height: '60px',
                    border: '1px solid #EE8865',
                    boxSizing: 'border-box',
                    color: '#000000',
                    margin: '1em'
                  }}
                  onClick={onClickCTA}
                >
                  Configure
                </Button>
              </Col>
            </Row>
          </Col>
          {getSummary && getSummary.data && getSummary.data.materials && (
            <LinesList list={getSummary.data.materials} />
          )}
          {getSummary && getSummary.data && getSummary.data.labor && (
            <>
              <LinesList list={getSummary.data.labor} showTotal={false} showPrice={false} />
              <Col span={24} md={20} lg={16}>
                <Divider style={{ margin: 0 }} />
                <Row justify="space-between">
                  <span className={_s.titlePlan}>Total Labor</span>
                  <span className={_s.summaryListItemTitle}>
                    ${formatPrice(getSummary.data.price.labor.min)} - $
                    {formatPrice(getSummary.data.price.labor.max)}*
                  </span>
                  <span className={_s.summaryListItemTitle}>
                    *Prices for labor differ dramatically depending on the location, availability,
                    and qualifications of the skilled workers. Please discuss with your local
                    professional to determine the cost of your project.
                  </span>
                </Row>
              </Col>
            </>
          )}
        </Row>
      </Col>
    </Row>
  );
};

export default Summary;
